import { render, staticRenderFns } from "./TableTemplateConfig.vue?vue&type=template&id=42cc7629&scoped=true&"
import script from "./TableTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./TableTemplateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc7629",
  null
  
)

export default component.exports